import {
  FOCUS_GO_NEXT_BUTTON,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta02Model } from './model-consultaSeguimentoPergunta02'
import { hasPergunta02IgnoraAnySim, isPergunta02IgnoraAllNao } from './utils-consultaSeguimentoPergunta02'

export const PERGUNTA_02_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta02Model> = {
  PERGUNTA_02_IGNORA: {
    scrollConditions: [
      {
        if: (value) => hasPergunta02IgnoraAnySim(value) || isPergunta02IgnoraAllNao(value),
        scrollTo: 'PERGUNTA_02_FEZ_EXAME',
      },
    ],
  },
  PERGUNTA_02_FEZ_EXAME: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_02_RESULTADO_EXAME',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: FOCUS_GO_NEXT_BUTTON,
      },
    ],
  },
  PERGUNTA_02_RESULTADO_EXAME: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: FOCUS_GO_NEXT_BUTTON,
      },
    ],
  },
}
